
export default {
    name: 'Theme2OfflinePage',
}
